@if (label) {
    <div class = "ui-label">
        {{ label }}
    </div>
}
@if (viewMode === 'menu') {
    <div #trigger class = "ui-select-container" [ngClass] = "{'ui-select-option-selected': valueContext , 'ui-select-small': small }" (click)="eventOpenOptions()">
        @if (valueContext) {
            @if (icon || valueContext.icon) {
                <div class = "ui-select-icon">
                    <i [class] = "valueContext.icon || icon"></i>
                </div>
            }
            <div class = "ui-detail-container">
                <span class = "ui-title" [style.font-weight]= " (valueContext?.description) ? 'bold' : 'normal'"> {{ valueContext?.name }}</span>
                <span class = "ui-sub-title">{{ valueContext?.description }}</span>
            </div>

        } @else {
            <div class="ui-detail-container">
                <span class="ui-title">{{ placeholder }}</span>
            </div>
        }
    </div>

    <ng-template #menuTemplate>
        <div class = "ui-select-menu" [ngClass] = "{ 'ui-selector-menu-small': small }">
            @if (!small) {
                <div class = "ui-field ui-secondary ui-field-without-border">
                    <i class = "ui-icon uii-search"></i>
                    <input type="text" class="ui-select-menu-search-input" placeholder = "Filtrar..." (input)="eventFilter($event)"/>
                </div>
            }

            <div class = "ui-select-options">
                @for (option of filteredOptions; track option.value) {
                    <div class="ui-select-option" (click)="eventOptionSelected(option)">
                        @if (option.description) {
                            <span class = "ui-title">{{ option.name }}</span>
                            <span class = "ui-sub-title">{{ option.description }}</span>
                        } @else {
                            {{ option.name }}
                        }
                    </div>
                }
            </div>
        </div>
    </ng-template>
} @else {
    <div class = "ui-select-inline-container">
        @for (option of filteredOptions; track option.value) {
            <div class = "ui-badge ui-selectable ui-secondary" [style]="{'pointer-events': disabledValues.includes(option.value) ? 'none' : 'cursor'}" (click) = "eventOptionSelected(option)" [ngClass] = "{ 'ui-badge-active': option.value === value }">
                {{ option.name }}
            </div>
        }
        @if (filteredOptions.length === 0) {
            <div class = "ui-empty-container">
                Nenhuma opção encontrada
            </div>
        }
    </div>
}
